import { TextField, TextInput, Labeled } from "react-admin";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ImportRemoteLockersButton from "../components/buttonImportRemoteLockers";
import { LocationField, LocationInput } from "./locations/components";
import { MyList } from "../ra-lb-tools/components/myList";
import {
  MyEdit as Edit,
  MyCreate as Create,
} from "../ra-lb-tools/components/myMutator";
import { SystemField, SystemInput } from "./systems";
import { RecordSummary, MyShow } from "../ra-lb-tools/components/MyShow";
import { LabeledColumn } from "../ra-lb-tools/components/labeledColumn";
import {
  MyTabbedShowLayout,
  Tab,
} from "../ra-lb-tools/components/myTabbedShowLayout";
import { LockerRequestList } from "./lockerRequest";
import { useParams } from "react-router";
import { UserInput } from "./users";
import {
  MyReferenceField,
  MyReferenceInput,
} from "../ra-lb-tools/components/myReference";
import { LockerProviderInput } from "./lockerProviders";

export const LocationIcon = LocationOnIcon;

const filters = () => [
  <TextInput source="id" alwaysOn key="id" />,
  <SystemInput source="system_id" alwaysOn key="system_id" />,
  <LocationInput source="location_id" alwaysOn key="location_id" />,
  <LockerProviderInput
    source="locker_provider_id"
    alwaysOn
    key="locker_provider_id"
  />,
];

export const FederationList = (props) => (
  <MyList {...props} resource="federations" filters={filters()}>
    <TextField source="id" />
    <TextField source="remoteId" />
    <SystemField label="System" />
    <LocationField label="Location" />
    <MyReferenceField
      source="lockerProviderId"
      reference="locker-providers"
      link="show"
    >
      <TextField source="name" />
    </MyReferenceField>
    <ImportRemoteLockersButton />
  </MyList>
);

export const FederationEdit = (props) => (
  <Edit {...props} labelField="remoteId">
    <TextInput disabled source="id" />
    <TextInput disabled source="remoteId" />
    <SystemInput disabled label="System" slack={10} />
    <LocationInput />
  </Edit>
);

export const FederationShow = (props) => {
  const { id } = useParams();

  return (
    <MyShow {...props} labelField="remoteId">
      <MyTabbedShowLayout>
        <Tab label="Summary" can={true}>
          <RecordSummary>
            <LabeledColumn>
              <TextField source="id" />
              <TextField source="remoteId" />
              <SystemField label="System" />
              <Labeled>
                <LocationField label="Location" />
              </Labeled>
              <MyReferenceField
                source="lockerProviderId"
                reference="locker-providers"
                link="show"
              >
                <TextField source="name" />
              </MyReferenceField>
            </LabeledColumn>
          </RecordSummary>
        </Tab>
        <Tab
          label="Locker Requests"
          path="locker-requests"
          can={{ action: "list", resource: "locker-request" }}
        >
          <LockerRequestList filter={{ federation_id: parseInt(id) }} />
        </Tab>
      </MyTabbedShowLayout>
    </MyShow>
  );
};

export const FederationCreate = (props) => (
  <Create {...props}>
    <TextInput source="remoteId" />
    <UserInput source="ownerId" />
    <TextInput source="systemName" />
    <MyReferenceInput source="lockerProviderId" reference="locker-providers" />
  </Create>
);
